import React, { useState } from 'react'
import { LINKEDIN_SIGNUP } from '../../Utils/apis';


const useSignupFromLinkedin = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fn = async (formData) => {
        if (!loading) {
            try {
                setLoading(true)
                const res = await fetch(LINKEDIN_SIGNUP, {
                    method: 'POST',
                    body: formData,
                    credentials: 'include',
                });

                if (!res.ok) {
                    const err = await res.json();
                    throw new Error(err.message);
                }

                const user = await res.json();

            } catch (error) {
                setError(error.message);
                return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }
        }
    }

    return [loading, error, fn];
}

export default useSignupFromLinkedin;
